import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import GlobalHelper from '../common/GlobalHelper.jsx';
import ActionButton from "../common/button/actionbutton.component.jsx";
import ConfirmButton from "../common/button/confirmbutton.component.jsx";
import NewCreditCardModal from "../common/credit-card/newcreditcardmodal.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import StandardList from '../common/listing/list.component.jsx';
import Integrations from '../integration/Integrations.jsx';
import CreditCardLabel from "../payment/creditcard.component.jsx";
import { PAYMENT_METHOD } from '../state/helpers/Payment';
import TestPaymentMethodBadge from './TestPaymentMethodBadge';

class CardsOnFileListByContact extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            modal: '',
            contactId: '',
            myAccountBilling: false,
            contact: null,
            organization: null,
            customerSelected: '',
            paymentIntegrationKey: AppContext.getPaymentIntegrationKey(),
            enableIntegratedPayment: AppContext.hasFeatureIntegration(Features.IntegratedPayment),
            className: this.props.className || '',
        }

        this.showAddNewCardModal = this.showAddNewCardModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.deleteCard = this.deleteCard.bind(this)
        this.setCardDefault = this.setCardDefault.bind(this)
    }

    componentDidMount() {
        const contactId = this.props.contactId || ''
        const myAccountBilling = this.props.myAccountBilling || false
        this.setState({
            myAccountBilling: myAccountBilling,
        }, () => {
            if (contactId || myAccountBilling) {
                this.loadContact(contactId)
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.contactId) {
            this.loadContact(nextProps.contactId)
        }
    }


    loadContact(contactId, callback) {
        const next = callback || function () { }
        let url = '/contacts/' + contactId
        if (this.state.myAccountBilling) {
            url = '/accounts/billing/contact'
        }
        AppContext.getApiClient().get(url).then(r => {
            this.setState({
                contactId: contactId,
                contact: r,
            }, () => {
                next()
            })
        })
    }

    deleteCard(cardId) {
        return function (e) {
            e.preventDefault()
            let url = '/contacts/' + this.state.contactId + '/cards-on-file/' + cardId
            if (this.state.myAccountBilling) {
                url = '/accounts/billing/cards-on-file/' + cardId
            }
            AppContext.getApiClient().delete(url).then(r => {
                this.loadContact(this.state.contactId)
            })
        }.bind(this)
    }

    setCardDefault(cardId) {
        return function (e) {
            e.preventDefault()
            let url = '/contacts/' + this.state.contactId + '/cards-on-file/' + cardId + '/default'
            if (this.state.myAccountBilling) {
                url = '/accounts/billing/cards-on-file/' + cardId + '/default'
            }
            AppContext.getApiClient().put(url, {}).then(r => {
                this.loadContact(this.state.contactId)
            })
        }.bind(this)
    }

    headers() {
        let headers = [
            <FormattedMessage
                id="customers.cards_on_file.list.headers.cardholder_name_label"
                defaultMessage="Cardholder name"
            />,
            <FormattedMessage
                id="customers.cards_on_file.list.headers.card_label"
                defaultMessage="Card"
            />,
            <FormattedMessage
                id="customers.cards_on_file.list.headers.expiry_date_label"
                defaultMessage="Expiry date"
            />,
        ]
        if (!this.state.myAccountBilling) {
            headers = headers.concat([
                <FormattedMessage
                    id="customers.cards_on_file.list.headers.created_at_label"
                    defaultMessage="Saved at"
                />,
                <FormattedMessage
                    id="customers.cards_on_file.list.headers.processor_label"
                    defaultMessage="Processor"
                />,
            ])
        }
        headers.push('')
        return headers
    }

    row(card) {
        const integration = GlobalHelper.getIntegrationById(card.attributes.integrationConfigurationId)
        const locationIds = integration ? integration.attributes.locationIds : []
        let locationName = ''
        if (locationIds.length > 0) {
            locationName = '(' + locationIds.map(id => {
                return GlobalHelper.getLocationById(id).attributes.name
            }).join(", ") + ')'
        }

        let row = [
            <span>
                {card.attributes.card.attributes.cardHolderName}
                {card.attributes.isDefault ? <span className="badge badge-primary ml-2">
                    <FormattedMessage
                        id="cards_on_file.default_label"
                        defaultMessage="Default"
                    />
                </span> : ''}
                {card.attributes.isTestPaymentMethod ? <TestPaymentMethodBadge paymentMethodType={PAYMENT_METHOD.CREDIT_CARD} /> : ''}
            </span>,
            <CreditCardLabel value={card.attributes.card} />,
            <span>{card.attributes.card.attributes.expirationMonth + '/' + card.attributes.card.attributes.expirationYear}</span>,
        ]

        if (!this.state.myAccountBilling) {
            row = row.concat([
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    weekday='long'
                    value={new Date(card.attributes.createdAt)} />,
                <span>
                    {Integrations.getIntegrationNameFromKey(card.attributes.integrationKey)} {locationName}
                </span>,
            ])
        }
        row.push(<div className={'w-100 d-flex justify-content-end'}>
            {!card.attributes.isDefault ? <ActionButton
                className={'btn btn-sm btn-outline-primary mr-2'}
                onClick={this.setCardDefault(card.id)}
            >
                <FormattedMessage
                    id="customer.cards_on_file.default_btn"
                    defaultMessage="Use by default"
                />
            </ActionButton> : ''}
            <ConfirmButton
                className={'btn btn-sm btn-outline-danger'}
                identifier={card.attributes.card.attributes.brand.toUpperCase() + ' - ' + card.attributes.card.attributes.last4}
                cardId={card.id}
                onClick={this.deleteCard(card.id)}
            >
                <Icon value={'trash'} className={'mr-1'} />
                <FormattedMessage
                    id="customer.cards_on_file.delete_btn"
                    defaultMessage="Remove"
                />
            </ConfirmButton>
        </div>)
        return row
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    showAddNewCardModal(event) {
        event.preventDefault()

        this.setState({
            modal: <NewCreditCardModal
                myAccountBilling={this.state.myAccountBilling}
                onClose={this.handleCloseModal}
                onSubmit={() => this.loadContact(this.state.contactId)}
                contactId={this.state.contactId}
                saveAndChargeLater={true} />
        })
    }

    render() {
        if (!this.state.contact) {
            return <div />
        }

        let cardsOnFile = this.state.contact.attributes.cardsOnFile
        if (!this.state.myAccountBilling) {
            cardsOnFile = cardsOnFile.filter(c => c.attributes.integrationKey === this.state.paymentIntegrationKey)
        }
        cardsOnFile = cardsOnFile.map(item => this.row(item))
        const headers = cardsOnFile.length > 0 ? this.headers() : []

        return (
            <div className={this.state.className}>
                <StandardList
                    smallLine={true}
                    className="row pt-0"
                    headers={headers}
                    rows={cardsOnFile}
                    footer={<div className="col-12 d-flex d-flex justify-content-between align-items-center">
                        <div></div>
                        {(this.state.enableIntegratedPayment || this.state.myAccountBilling) &&
                            <div>
                                <button onClick={this.showAddNewCardModal} className="btn btn-sm btn-primary">
                                    <Icon value={'plus-circle'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="customers.cards_on_file.new_card_btn"
                                        defaultMessage="Add a credit card"
                                    />
                                </button>
                            </div>
                        }
                    </div>}
                />
                {this.state.modal}
            </div>
        );
    }
}

export default CardsOnFileListByContact





// WEBPACK FOOTER //
// ./src/customer/cardonfileslist.component.jsx